export const AKLAMIO_VP_CODE = '401817';
export const sessionStorageName = {
    aklamioId: 'aklamioId',
    uvpCode: 'uvpCode',
    vpCode: 'vpCode'
};

//# sourceMappingURL=constants.js.map